import React from 'react';
import { Radio as RxRadio } from 'src/core/forms';

type InputProps = {
    label: string;
    value: string;
    id: string;
};

export const Radio: React.FC<InputProps> = (props) => {
    const { label, value, id } = props;
    return (
        <label htmlFor={id} className="labelRadio">
            <RxRadio value={value} id={id} />
            {label}
        </label>
    );
};
